<template>
  <div :class="$style.wrapper">
    <WhiteHeader :title="'Хаб'" />
    <div :class="$style.inner">
      <Hero />
      <Certificate />
      <div :class="$style.title">Пройденные задания</div>
      <div :class="$style.items">
        <TaskCard
          v-for="(item, index) in results"
          :key="index"
          v-bind="item"
          @click="() => { $userStory.setOverflowRoutes(item.id).moveRouter() }"
        />
      </div>
      <div :class="$style.title">Пройденные уроки</div>
      <div :class="$style.items">
        <LessonCard
          :title="'Урок 1 «Большие данные»'"
          :active="true"
          :image="require('./assets/lesson1.svg')"
        />
        <LessonCard
          :title="'Урок 2 «Сети и облачные технологии»'"
          :active="false"
        />
        <LessonCard
          :title="'Урок 3 «Персональные помощники»'"
          :active="false"
        />
        <LessonCard
          :title="'Урок 4 «Безопасность будущего»'"
          :active="false"
        />
        <LessonCard
          :title="'Урок 5 «ИИ и алгоритмы принятия решений»'"
          :active="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import WhiteHeader from '@/components/WhiteHeader/WhiteHeader.vue'

import Hero from './components/Hero/Hero.vue'
import TaskCard from './components/TaskCard/TaskCard.vue'
import LessonCard from './components/LessonCard/LessonCard.vue'
import Certificate from './components/Certificate/Certificate.vue'

import routerCheck from '@/mixins/routerCheck'

export default {
  name: 'Hub',
  components: {
    WhiteHeader, Hero, TaskCard, LessonCard, Certificate,
  },
  mixins: [routerCheck],
  computed: {
    results() {
      return this.$store.state.results
    },
  },
  created() {
    this.$store.dispatch('saveResults')
  },
}
</script>
<style lang="scss" module>
@import './Hub.scss';
</style>
